var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.newVersionAvailable)?_c('div',{staticClass:"version-alert"},[_vm._v(" 🔄 New Version found "),_c('button',{on:{"click":_vm.reloadPage}},[_vm._v("Reload")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }